import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Moment from 'react-moment';
import 'moment/locale/ru';
import api from '../../api';
import { PageContent, Breadcrumbs, PreLoader } from '../../components';
import styles from './style.module.css';

const ConferenceDetail = () => {
    const { id } = useParams();
    const [conference, setConference] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError(false);
        setConference(null);

        api.getConference(id)
            .then((data) => {
                if (active) setConference(data);
            })
            .catch(() => {
                if (active) setError(true);
            })
            .finally(() => {
                if (active) setLoading(false);
            });

        return () => { active = false; };
    }, [id]);

    if (loading) return <PreLoader />;

    if (error || !conference) {
        return (
            <div className={styles.detail_area}>
                <PageContent title="Конференция">
                    <p role="alert">Не удалось загрузить конференцию. Проверьте адрес или попробуйте позже.</p>
                    <Link to="/conferences/">Вернуться к списку конференций</Link>
                </PageContent>
            </div>
        );
    }

    const hasDateRange = conference.end_date && conference.end_date !== conference.start_date;
    const sameYear = conference.start_date.slice(0, 4) === conference.end_date?.slice(0, 4);
    const sameMonth = conference.start_date.slice(0, 7) === conference.end_date?.slice(0, 7);
    const startDateFormat = hasDateRange
        ? (sameMonth ? 'DD' : sameYear ? 'DD MMMM' : 'DD MMMM YYYY[г.]')
        : 'DD MMMM YYYY[г.]';

    return (
        <div className={styles.detail_area}>
            <PageContent title={conference.name} as="article" className={styles.detail}>
                <Breadcrumbs urls={[
                    { title: 'Отчеты о конференциях', path: '/conferences/' },
                    { title: conference.name, path: '' }
                ]} />
                <div className={styles.detail_date}>
                    <Moment locale="ru" format={startDateFormat}>{conference.start_date}</Moment>
                    {hasDateRange && <>
                        {' - '}
                        <Moment locale="ru" format="DD MMMM YYYY[г.]">{conference.end_date}</Moment>
                    </>}
                </div>
                {conference.location && <section>
                    <h2>Место проведения</h2>
                    <p className={styles.detail_text}>{conference.location}</p>
                </section>}
                {conference.conference_school?.length > 0 && <section>
                    <h2>Секции конференции</h2>
                    <ul>
                        {conference.conference_school.map((school) => (
                            <li key={school.id}>{school.name}</li>
                        ))}
                    </ul>
                </section>}
                {conference.conference_doc?.length > 0 && <section>
                    <h2>Документы и материалы</h2>
                    <ul>
                        {conference.conference_doc.map((document) => (
                            <li key={document.id}>
                                <a href={document.file} target="_blank" rel="noreferrer">{document.title}</a>
                            </li>
                        ))}
                    </ul>
                </section>}
                <Link to="/conferences/">Все конференции</Link>
            </PageContent>
        </div>
    );
};

export default ConferenceDetail;
